import React from "react";
import { BannerPageViewType } from "../../generated/CoreApi_v1";
import { BannerCarousel } from "../foundation/banner/components/BannerCarousel";

export const HomeBanner: React.FC = () => {

    return (
        <>
            <BannerCarousel pageView={BannerPageViewType.Welcome} margin="large" />
        </>
    );
};
